import styled from "styled-components";

export const MainWrapper = styled.div`
    display: block;
    overflow: auto;
    width: 100%;
    height: 100%;
    
    &::-webkit-scrollbar {
        display: none;
        width: 0px;
    }
    
    &::-webkit-scrollbar-thumb {
        background-color: transparent;
        border-radius: 5px;
    }
    
    &::-webkit-scrollbar-track {
        background-color: transparent;
    }
`;

export const MainLayoutWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
    width: 100%;
    height: 100%;
`;

export const MainContentLayoutWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    height: 100%;
`;

export const SideBarWrapper = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 76px;
    background-color: #FFFFFF;
    border-top: 1px solid #EEEEEE;
    z-index: 10;
`;

export const StatusBarWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 48px;
    background-color: #FFFFFF;
    border-bottom: 1px solid #EEEEEE;
    z-index: 10;
`;

export const ContentWrapper = styled.div`
    flex: 1 1 0px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding-bottom: 90px;
    padding-top: 48px;
`;

export const RouterWrapper = styled.div`
    flex: 1 1 0px;
    overflow: hidden;
`;
